import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import FormInput from "../inputs/FormInput";
import LanguageToggle from "../global/LanguageToggle";

const FormValueSection = ({ currentData, onSubmit, isLoading }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");
    const initialLang = localStorage.getItem("i18nextLng") || i18next.language || "ar";
    const [activeLang, setActiveLang] = useState(initialLang.startsWith("ar") ? "ar" : "en");

    const [image, setImage] = useState(null);
    const [titleAr, setTitleAr] = useState("");
    const [titleEn, setTitleEn] = useState("");
    const [subTitleAr, setSubTitleAr] = useState("");
    const [subTitleEn, setSubTitleEn] = useState("");
    const [descriptionAr, setDescriptionAr] = useState("");
    const [descriptionEn, setDescriptionEn] = useState("");

    useEffect(() => {
        if (currentData) {
            setImage(currentData?.image || null);
            setTitleAr(currentData?.title?.ar || "");
            setTitleEn(currentData?.title?.en || "");
            setSubTitleAr(currentData?.sub_title?.ar || "");
            setSubTitleEn(currentData?.sub_title?.en || "");
            setDescriptionAr(currentData?.description?.ar || "");
            setDescriptionEn(currentData?.description?.en || "");
        }
    }, [currentData]);

    const getImageName = (imageVal) => {
        if (!imageVal) return "";
        if (typeof imageVal === 'string') {
            return imageVal.substr(imageVal.lastIndexOf('/') + 1);
        }
        if (imageVal?.file_name) return imageVal.file_name;
        if (imageVal?.name) return imageVal.name;
        return imageVal;
    };

    const handleImageChange = (e) => {
        setImage(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            title: {
                ar: titleAr || titleEn,
                en: titleEn || titleAr,
            },
            sub_title: {
                ar: subTitleAr || subTitleEn,
                en: subTitleEn || subTitleAr,
            },
            description: {
                ar: descriptionAr || descriptionEn,
                en: descriptionEn || descriptionAr,
            },
            image: getImageName(image),
        };

        onSubmit(payload);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Typography variant="h6">
                        {isArabic ? "بيانات قسم القيم" : "Values Section Data"}
                    </Typography>
                    <LanguageToggle activeLang={activeLang} onChange={(lng) => setActiveLang(lng)} showLabel={true} />
                </Box>

                <Grid container spacing={3}>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <FormInput
                            type="file"
                            name="image"
                            labelImage={isArabic ? "صورة القسم" : "Section Image"}
                            value={image}
                            onChange={handleImageChange}
                            width={200}
                            height={120}
                        />
                    </Grid>

                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان (عربي)"
                                placeholder="أدخل العنوان بالعربي"
                                value={titleAr}
                                onChange={(e) => setTitleAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Title (English)"
                                placeholder="Enter title in English"
                                value={titleEn}
                                onChange={(e) => setTitleEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان الفرعي (عربي)"
                                placeholder="أدخل العنوان الفرعي بالعربي"
                                value={subTitleAr}
                                onChange={(e) => setSubTitleAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Sub Title (English)"
                                placeholder="Enter sub title in English"
                                value={subTitleEn}
                                onChange={(e) => setSubTitleEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "ar" && (
                        <Grid item xs={12}>
                            <FormInput
                                type="textarea"
                                label="الوصف (عربي)"
                                placeholder="أدخل الوصف بالعربي"
                                value={descriptionAr}
                                onChange={(e) => setDescriptionAr(e.target.value)}
                                multiline
                                rows={4}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12}>
                            <FormInput
                                type="textarea"
                                label="Description (English)"
                                placeholder="Enter description in English"
                                value={descriptionEn}
                                onChange={(e) => setDescriptionEn(e.target.value)}
                                multiline
                                rows={4}
                                fullWidth
                            />
                        </Grid>
                    )}
                </Grid>

                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={isLoading}
                        sx={{ minWidth: 120 }}
                    >
                        {isLoading ? (isArabic ? "جاري الحفظ..." : "Saving...") : (isArabic ? "حفظ" : "Save")}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default FormValueSection;
